import React from 'react'
import { Grid, styled, Typography, useTheme } from '@mui/material'
import useMediaQuery from '@material-ui/core/useMediaQuery';

// Turns out Mui has their own impl of image list. Might be worth looking into that

const ImageFrame = styled(`img`)(({theme}) => ({
    borderRadius: '20px',
    border: `3px solid ${theme.palette.neutral.main}`,
    width: '218px',
    height: '218px',
    marginBottom: '25px',
    [theme.breakpoints.down('lg')]: {
        width: '189px',
        height: '189px',
    }
}))

const TeamProfile = styled(`div`)(({theme}) => ({
    borderRadius: '20px',
    width: '218px',
    height: 'auto',
    [theme.breakpoints.down('lg')]: {
        width: '189px',
    }
}))

const CaptionFrame = styled(`div`)(({theme}) => ({
    borderRadius: '20px',
    width: '218px',
    height: 'auto',
    [theme.breakpoints.down('lg')]: {
        width: '189px',
    }
}))


export function TeamProfileList(props) {
    const { lowerCount, images, imageKey, spacing, alignment, captions, captionHeading } = props;
    const theme = useTheme()
    const largeScreen = useMediaQuery(() => theme.breakpoints.up('md'));
    return (
        <Grid gridRow={1} container direction={largeScreen?"row":"column"}   spacing={2} columnSpacing={{ md: spacing }} rowSpacing={1} wrap="nowrap" justifyContent={alignment} align='center'>
            {
                images.map((image, index) => {
                    const hide = !!lowerCount && index >= lowerCount ? 'none' : 'block';
                    return (
                        <Grid item xs={12} sm='auto' key={`${imageKey}_${index}`} sx={{
                            display: { xs: `${hide}`, md: 'block' },
                        }}>
                            <TeamProfile>
                                <ImageFrame src={image}/>
                                <CaptionFrame>
                                <Typography sx={{ marginBottom: '25px'}}component={'div'} variant="h3">
                                        {!!captionHeading ? captionHeading[index] : ""}
                                </Typography>

                                <Typography component={'div'} variant="body1">
                                        {!!captions ? captions[index] : ""}
                                </Typography>
                                </CaptionFrame>
                            </TeamProfile>
                        </Grid>
                    )
                })
            }
        </Grid>

    )


}